import React from "react";
import { useTheme } from "./ThemeContext";

const ThemeToggle = () => {
   const { theme, toggleTheme } = useTheme();
   const isLight = theme === "light";

   return (
      <button
         onClick={toggleTheme}
         className="theme-toggle"
         title={`Switch to ${isLight ? "dark" : "light"} mode`}
         aria-label={`Switch to ${isLight ? "dark" : "light"} mode`}
         style={{
            backgroundColor: isLight ? "#E5E7EB" : "rgba(255, 255, 255, 0.1)",
            border: "none",
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.3s ease",
            position: "relative",
            overflow: "hidden",
         }}
      >
         <div
            style={{
               position: "absolute",
               top: 0,
               left: 0,
               right: 0,
               bottom: 0,
               display: "flex",
               alignItems: "center",
               justifyContent: "center",
               transform: `translateY(${isLight ? "0" : "-100%"})`,
               transition: "transform 0.3s ease",
            }}
         >
            {/* Moon icon for light theme (switch to dark) */}
            <svg
               width="20"
               height="20"
               viewBox="0 0 24 24"
               fill="none"
               stroke={isLight ? "#1F2937" : "currentColor"}
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            >
               <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
            </svg>
         </div>

         <div
            style={{
               position: "absolute",
               top: 0,
               left: 0,
               right: 0,
               bottom: 0,
               display: "flex",
               alignItems: "center",
               justifyContent: "center",
               transform: `translateY(${isLight ? "100%" : "0"})`,
               transition: "transform 0.3s ease",
            }}
         >
            {/* Sun icon for dark theme (switch to light) */}
            <svg
               width="20"
               height="20"
               viewBox="0 0 24 24"
               fill="none"
               stroke={isLight ? "currentColor" : "#FFFFFF"}
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            >
               <circle cx="12" cy="12" r="5"></circle>
               <line x1="12" y1="1" x2="12" y2="3"></line>
               <line x1="12" y1="21" x2="12" y2="23"></line>
               <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
               <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
               <line x1="1" y1="12" x2="3" y2="12"></line>
               <line x1="21" y1="12" x2="23" y2="12"></line>
               <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
               <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
            </svg>
         </div>
      </button>
   );
};

export default ThemeToggle;
